module.exports = __webpack_public_path__ + "static/img/BoycottBarImage@2x.c5e43ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/BoycottBarImage@2x.png
// module id = 2nZj
// module chunks = 0